/* Template reference prices. The public Admin bundle is the same authority
 * the calculator/product page reads. Money is composed by the storefront
 * core, never by a parallel base/add-on formula. A failed read is not a
 * legacy product. Cache promises for this page only, including failures. */
(function () {
  'use strict';
  if (window.BGReferencePricing) return;
  var requests = Object.create(null);
  var BUNDLE_KEYS = ['productCommerceBundle', 'compiledProductCommerceBundle', 'productCommerceRuntime'];
  var ARTWORK_KEYS = ['artworkMethodHolderId', 'artworkMethodHolderHtmlId', 'artworkMethodHolderTargetingId', 'artworkMethodHolderName', 'methodHolderId', 'methodHolderHtmlId', 'methodHolderTargetingId', 'methodHolderName'];
  // Template attributes and the newer browser's Style handoff, read as
  // <name>_targetingID: the choices the product page link selects.
  var DESIGN_KEYS = ['size', 'shape', 'orientation', 'corners', 'perforation', 'fold', 'fit', 'equipment', 'Printing', 'Style'];
  var UNAVAILABLE = '<p class="no-pricing">Pricing will be confirmed on the product page.</p>';
  function text(value) { return String(value == null ? '' : value).trim(); }
  function object(value) { return value && typeof value === 'object' && !Array.isArray(value) ? value : null; }
  function integer(value) { return Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : 0; }
  function optionMatches(option, value) { return !!value && (text(option && (option.targetingId || option.targetingID)) === value || text(option && option.id) === value); }
  function holderNamed(holder, name) { return [holder.role, holder.label, holder.customLabel, holder.id].some(function (label) { return text(label).toLowerCase() === name.toLowerCase(); }); }
  // Broad on purpose: a value any rule might name counts as rule-driven.
  function matchKey(value) { return text(value).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  // The product the browsers link to: the same precedence as their own
  // product identity (bg-template-collection productHandle and
  // bg-designs-collection normalizedTemplateCollectionTargetHandle).
  var HANDLE_KEYS = ['__foundationTargetProductHandle', '__foundationReturnProductHandle', '__foundationTargetTemplateSourceHandle', '__foundationTemplateSourceHandle', 'product_handle', 'productHandle', 'handle'];
  function handle(design) {
    for (var i = 0; i < HANDLE_KEYS.length; i += 1) {
      var value = text(design && design[HANDLE_KEYS[i]]).toLowerCase();
      if (value) return value;
    }
    return '';
  }
  // The presenters link through __foundationProductUrl first (the return
  // product). A link to another product page than the one read here shows no
  // amount, Admin or legacy: each presenter checks it before choosing.
  function linksElsewhere(design) {
    var linked = /\/products\/([^/?#]+)/i.exec(text(design && design.__foundationProductUrl));
    return !!linked && linked[1].toLowerCase() !== handle(design);
  }
  function storeKey(options) { return text(options && options.storeKey) || text(window.BGReferencePricingConfig && window.BGReferencePricingConfig.storeKey); }
  function key(options) { return storeKey(options) + '|' + text(options && options.productHandle); }

  function load(options) {
    var cacheKey = key(options);
    if (requests[cacheKey]) return requests[cacheKey].promise;
    var entry = { status: 'pending', payload: null, root: null, bundle: null, storeKey: storeKey(options) };
    requests[cacheKey] = entry;
    var store = storeKey(options), product = text(options && options.productHandle);
    if (!store || !product) {
      entry.status = 'unavailable';
      entry.promise = Promise.resolve(entry);
      return entry.promise;
    }
    var query = new URLSearchParams({ storeKey: store, productHandle: product });
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
    var init = { credentials: 'same-origin', cache: 'no-store', headers: { accept: 'application/json' } };
    if (controller) init.signal = controller.signal;
    entry.promise = Promise.resolve().then(function () {
      return (options.fetch || window.fetch.bind(window))('/apps/qps-commerce-control-plane/designer/product-editor-config?' + query.toString(), init);
    }).then(function (response) {
      return response && response.ok ? response.json() : null;
    }).then(function (payload) {
      var root = object(payload);
      if (root && root.ok === false) { entry.status = 'unavailable'; return entry; }
      if (root && object(root.result)) root = root.result;
      entry.status = 'unavailable';
      if (!root || root.ok !== true || (root.storeKey && root.storeKey !== store) || (root.productHandle && root.productHandle !== product)) return entry;
      entry.payload = payload;
      entry.root = root;
      // The public payload states its Product Commerce configuration
      // (configurationStatus: configured, unconfigured, invalid or
      // unavailable). An invalid saved configuration omits the bundle too, so
      // only an explicit 'unconfigured' without commerce fields keeps the
      // legacy prices, and only 'configured' with a bundle prices from Admin.
      // Refused, malformed and HTTP failures show no amount.
      var configurationStatus = text(root.configurationStatus);
      var present = BUNDLE_KEYS.filter(function (name) { return Object.prototype.hasOwnProperty.call(root, name); });
      if (!present.length) {
        if (configurationStatus === 'unconfigured' && root.storeKey === store && root.productHandle === product) entry.status = 'legacy';
        return entry;
      }
      entry.bundle = object(root[present[0]]);
      if (configurationStatus === 'configured' && entry.bundle && entry.bundle.version === 1) entry.status = 'admin';
      return entry;
    }).catch(function () { entry.status = 'unavailable'; return entry; }).then(function (result) {
      if (timer) clearTimeout(timer);
      return result;
    });
    return entry.promise;
  }

  function peek(options) { return requests[key(options)] || null; }
  function selectionKey(ids) { return Object.keys(ids).sort().map(function (id) { return id + '=' + ids[id]; }).join('|'); }

  // Byte-for-byte the product page/calculator's tier sale arithmetic.
  function tierSaleLineCents(lineCents, pct, quantity) {
    var cents = Math.round(Number(lineCents));
    var rate = Math.round(Number(pct));
    var count = Math.max(1, Math.floor(Number(quantity) || 1));
    if (!Number.isSafeInteger(cents) || cents <= 0 || !(rate > 0) || rate >= 100) return cents;
    var unit = Math.floor(cents / count);
    var cut = unit * rate;
    return count * (unit - ((cut - (cut % 100)) / 100));
  }

  function rows(entry, design) {
    var core = window.BGDesignerStorefrontCore;
    if (!entry || entry.status !== 'admin' || !core || ['scaleMoney', 'roundMoney', 'buildOptionSelection', 'buildDesignerSplitPrice'].some(function (name) { return typeof core[name] !== 'function'; })) return null;
    var bundle = entry.bundle, target = object(bundle.target), quantity = object(bundle.quantity);
    if (!target || !quantity) return null;
    if (['min', 'max', 'step'].some(function (name) { return quantity[name] != null && (typeof quantity[name] !== 'number' || !integer(quantity[name])); })) return null;
    if (quantity.min && quantity.max && quantity.min > quantity.max) return null;
    if ((target.storeKey && target.storeKey !== entry.storeKey) || (target.targetHandle && target.targetHandle !== handle(design))) return null;
    if (linksElsewhere(design)) return null;
    // As the calculator: rules that can change choices, prices or purchase
    // eligibility, and apparel size quantities, need the product page's state.
    if (text(quantity.fieldType).toLowerCase() === 'size_quantity_inputs') return null;
    if (bundle.rules != null && (!Array.isArray(bundle.rules) || bundle.rules.some(function (rule) {
      return !rule || !Array.isArray(rule.actions) || rule.actions.some(function (action) { return ['legacy_ui_class', 'set_sides_policy'].indexOf(text(action && action.type).toLowerCase()) < 0; });
    }))) return null;
    var pricing = object(bundle.pricing), source = pricing && pricing.rows;
    if (!Array.isArray(source) || !source.length || !Array.isArray(bundle.optionHolders)) return null;
    var seen = Object.create(null), pairs = Object.create(null);
    if (source.some(function (row) {
      var ids = object(row && row.holderValueIds), qty = integer(row && row.quantity), sku = text(row && row.sku);
      if (!ids || !qty || typeof row.quantity !== 'number' || typeof row.price !== 'number' || !sku || sku.slice(-String(qty).length) !== String(qty) || !(row.price > 0) || !Number.isSafeInteger(Math.round(row.price * 100))) return true;
      var pair = selectionKey(ids) + '#' + qty;
      if (seen[sku] || pairs[pair]) return true;
      seen[sku] = true; pairs[pair] = true;
      return false;
    })) return null;
    var details = object(entry.root.productDetails) || object(entry.root.productData) || {};
    var artwork = object(details.artworkSection) || object(details.artworkSectionConfig) || {};
    var artworkRefs = ARTWORK_KEYS.map(function (name) { return text(artwork[name]).toLowerCase(); }).filter(Boolean);
    var holders = bundle.optionHolders.filter(function (holder) { return holder && text(holder.fieldType).toLowerCase() !== 'hidden'; });
    if (new Set(holders.map(function (holder) { return holder.id; })).size !== holders.length) return null;
    var selected = Object.create(null);
    var prefix = text(design && design.base_partial_sku);
    var anchoredRows = prefix ? source.filter(function (row) { return row.sku.indexOf(prefix + '-q') === 0; }) : [];
    var invalid = false;
    var explicitPairs = [];
    DESIGN_KEYS.forEach(function (name) {
      var value = text(design && design[name + '_targetingID']);
      if (!value) return;
      // The page ignores template attributes for which this product has no
      // option holder (e.g. Printing on a product with only Size and Sides).
      var matchingValue = holders.some(function (holder) { return Array.isArray(holder.variations) && holder.variations.some(function (option) { return optionMatches(option, value); }); });
      var matchingHolder = holders.some(function (holder) { return holderNamed(holder, name); });
      if (!matchingValue && matchingHolder) invalid = true;
      if (matchingValue) explicitPairs.push({ name: name, value: value });
    });
    if (invalid) return null;
    var explicit = explicitPairs.map(function (pair) { return pair.value; });
    // The product page selects a template's option values through the Admin
    // option-source rules (templatePickerUi.optionSourceRules) when it opens
    // from a template. A priced option those rules can select is quoted only
    // with the choice the link itself names for that option (the newer
    // browser's Style); otherwise the page's choice is unknown here.
    var pickerUi = object(details.templatePickerUi) || {};
    var ruleKeys = [];
    (Array.isArray(pickerUi.optionSourceRules) ? pickerUi.optionSourceRules : []).forEach(function (rule) {
      (rule && Array.isArray(rule.optionValues) ? rule.optionValues : []).forEach(function (value) {
        var ruleKey = matchKey(value);
        if (ruleKey) ruleKeys.push(ruleKey);
      });
    });
    function ruleDriven(option) {
      return [option.label, option.customLabel, option.displayLabel, option.value, option.targetingId, option.targetingID, option.id].some(function (value) {
        var optionKey = matchKey(value);
        return !!optionKey && ruleKeys.indexOf(optionKey) >= 0;
      });
    }
    var matchedTargets = Object.create(null), selections = [], pricingHolderIds = [];
    holders.forEach(function (holder, index) {
      var values = Array.isArray(holder.variations) ? holder.variations.filter(function (value) {
        return value && (!Array.isArray(holder.variationIds) || !holder.variationIds.length || holder.variationIds.indexOf(value.id) >= 0);
      }) : [];
      if (!text(holder.id) || !values.length || new Set(values.map(function (value) { return value.id; })).size !== values.length || values.some(function (value) { return !text(value.id); })) { invalid = true; return; }
      var isArtwork = [holder.id, holder.label, holder.customLabel].some(function (token) { return artworkRefs.indexOf(text(token).toLowerCase()) >= 0; });
      if (isArtwork) return;
      var explicitValues = values.filter(function (value) { return explicit.some(function (id) { return optionMatches(value, id); }); });
      if (explicitValues.length > 1) { invalid = true; return; }
      var priced = (holder.role !== 'addon' && holder.skuBehavior !== 'ignored') || values.some(function (value) { return Number(value.addonPrice) !== 0 && value.addonPrice != null; });
      // The page reads a link parameter by the option's label, own label or id.
      if (priced && ruleKeys.length && values.some(ruleDriven) && !explicitPairs.some(function (pair) {
        return [holder.label, holder.customLabel, holder.id].some(function (label) { return text(label).toLowerCase() === pair.name.toLowerCase(); })
          && values.some(function (value) { return optionMatches(value, pair.value); });
      })) { invalid = true; return; }
      // The destination preselects the template's explicit URL targets and
      // the product's configured defaults. A legacy code must not silently
      // substitute a different option just because it still has an Admin row.
      var choice = explicitValues[0] || values.find(function (value) { return value.defaultValue === true; }) || values[0];
      if (!choice || choice.outOfStock === true) { invalid = true; return; }
      explicit.forEach(function (id) { if (explicitValues.length && optionMatches(explicitValues[0], id)) matchedTargets[id] = true; });
      var addon = object(choice.addon) || {};
      var price = choice.addonPrice == null ? 0 : Number(choice.addonPrice);
      if ((choice.addonPrice != null && typeof choice.addonPrice !== 'number') || !Number.isFinite(price) || !Number.isSafeInteger(Math.round(price * 100))) { invalid = true; return; }
      selected[holder.id] = choice.id;
      if (holder.role !== 'addon' && holder.skuBehavior !== 'ignored') pricingHolderIds.push(holder.id);
      var selection = core.buildOptionSelection({ id: holder.id, htmlID: text(holder.label) || holder.id, displayName: holder.customLabel || holder.label, sortOrder: index + 1 }, { hvId: choice.id, label: choice.label, targetingID: choice.targetingId, addonPrice: price }, index + 1);
      Object.assign(selection, {
        addonKey: text(choice.targetingId).toLowerCase(),
        addonBasePrice: price,
        addonType: text(addon.addonType),
        addonLabel: text(addon.addonLabel),
        addonName: text(addon.addonName),
        discountEligible: addon.discountEligible === true,
        excludeFromCart: addon.excludeFromCart === true,
        useTypedQuantity: addon.useTypedQuantity === true,
        isPostage: addon.isPostage === true
      });
      selections.push(selection);
    });
    if (invalid || explicit.some(function (id) { return !matchedTargets[id]; })) return null;
    if (!anchoredRows.length && !explicit.length && pricingHolderIds.length) return null;
    var matching = source.filter(function (row) {
      var ids = row.holderValueIds;
      return Object.keys(ids).every(function (id) { return selected[id] === ids[id]; })
        && Object.keys(ids).length === pricingHolderIds.length
        && pricingHolderIds.every(function (id) { return ids[id] === selected[id]; });
    });
    // Do not guess between different price code families for one selection.
    var prefixes = new Set(matching.map(function (row) { return row.sku.slice(0, -String(row.quantity).length); }));
    if (prefixes.size !== 1) return null;
    var saleMap = window.productTierSalePercents || {};
    var productHandle = handle(design);
    if (!Object.prototype.hasOwnProperty.call(saleMap, productHandle)) return null;
    var pct = Number(saleMap[productHandle]);
    if (!Number.isInteger(pct) || pct < 0 || pct >= 100) return null;
    var result = [];
    matching.forEach(function (row) {
      var qty = row.quantity;
      if (quantity.lockedToPricingTable !== true && ((integer(quantity.min) && qty < Number(quantity.min)) || (integer(quantity.max) && qty > Number(quantity.max)) || (integer(quantity.step) && integer(quantity.min) && (qty - Number(quantity.min)) % Number(quantity.step)))) return;
      var split = core.buildDesignerSplitPrice({
        basePrice: core.scaleMoney(row.price, 1, 1),
        finalSku: row.sku,
        quantity: qty,
        typedQty: qty,
        optionSelections: selections,
        holdCreditsFromSale: target.saleDiscountBps > 0 && target.saleDiscountBps < 10000
      });
      var list = core.roundMoney(split.productTotal);
      var total = pct ? tierSaleLineCents(Math.round(list * 100), pct, 1) / 100 : list;
      if (!(list > 0) || !(total > 0) || !Number.isSafeInteger(Math.round(list * 100)) || !Number.isSafeInteger(Math.round(total * 100)) || split.optionAddOns.breakdown.some(function (addon) { return !Number.isFinite(addon.amount); })) { invalid = true; return; }
      result.push({ quantity: qty, listTotal: list, total: total, unit: pct ? Math.ceil(Math.round(total * 100) / qty - 1e-7) / 100 : core.roundMoney(total / qty), isDefault: row.defaultQty === true });
    });
    return invalid || !result.length ? null : result.sort(function (a, b) { return a.quantity - b.quantity; });
  }

  function tableHtml(entry, design, discountPct) {
    var quoted = rows(entry, design);
    if (!quoted) return UNAVAILABLE;
    var html = '<table class="price-table"><thead><tr><th>Quantity</th><th>Price</th></tr></thead><tbody>';
    quoted.forEach(function (row) {
      html += '<tr><td>' + row.quantity + '</td><td>';
      if (row.total < row.listTotal) html += '<s>$' + row.listTotal.toFixed(2) + '</s> <span class="bg-dc-sale-price">$' + row.total.toFixed(2) + '</span>';
      else html += '$' + row.total.toFixed(2);
      html += '&nbsp;<em>($' + row.unit.toFixed(2) + '/ea)</em></td></tr>';
    });
    html += '</tbody></table>';
    if (discountPct > 0 && !Number((window.productTierSalePercents || {})[handle(design)])) html += '<p class="bg-dc-sale-pending-note" role="status">Price before discounts. Final discounts are calculated at checkout.</p>';
    return html;
  }

  window.BGReferencePricing = { load: load, peek: peek, rows: rows, tableHtml: tableHtml, handle: handle, linksElsewhere: linksElsewhere, unavailableHtml: UNAVAILABLE, tierSaleLineCents: tierSaleLineCents };
})();
